import { render, staticRenderFns } from "./FichettesA5.vue?vue&type=template&id=4ac53834&"
import script from "./FichettesA5.vue?vue&type=script&lang=js&"
export * from "./FichettesA5.vue?vue&type=script&lang=js&"
import style0 from "./FichettesA5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports